import { Alert, AlertDescription, AlertIcon, Center } from '@chakra-ui/react';

export function NoPermissionsPage() {
  return (
    <Center bg="bg.emphasized" h="100vh" maxW="100vw">
      <Alert status="error" maxW="50vw">
        <AlertIcon />

        <AlertDescription>
          No cuenta con permisos para utilizar esta aplicación.
        </AlertDescription>
      </Alert>
    </Center>
  );
}
